module.exports = __webpack_public_path__ + "img/chevron_left_black_24dp.77e99d68.svg";